export default __webpack_public_path__ + "img/download.8cf2c822.svg";